import { commonEnv } from "./environment.common";
import { Configuration as MsalConfig } from "@azure/msal-browser";

const clientId = "c83d2b16-0a42-40ce-bdaf-41bb8e6aba02";
const scopes = ["https://iaptstb2c.onmicrosoft.com/api/read"];
const appUrl = "https://iap-tst.senecapolytechnic.ca";

// const clientId = "900edae6-4461-4ef5-ad4d-7f6e376a3a13";
// const scopes = [clientId];
// const appUrl = "http://localhost:4200";

//const azureInstance = commonEnv.azureInstance_v2;
const azureInstance = `https://iaptstb2c.b2clogin.com/tfp`;
const tenant = "iaptstb2c.onmicrosoft.com";
const tenantName = "iaptstb2c";

export class BuildEnvironment {
  constructor() {}

  public static GetEnvironmentUrl(): string {
    return environment.apiUrl;
  }
}

export const environment = {
  production: false,
  appUrl: appUrl,
  scopes: scopes,
  clientId: clientId,
  autoEvalUrl: "https://autoeval-appsvc-web01ts.azurewebsites.net/student-form",
  apiUrl: "https://seneapi-apims-tst.azure-api.net/iwa",
  //apiUrl: "http://localhost:3000/iwa-api",
  apiSubscriptionKey: "1939355f5c8244deafe449feadec925d",
  apiSubscriptionEnabled: true,
  monerisServiceUrl:
    "https://seneapi-apims-dv.azure-api.net/MonerisCheckoutServices/public/controllers",
  monerisAppName: "IWAFEES",
  agentSignInPolicy: commonEnv.agentSignInPolicy,
  applicantSignInPolicy: commonEnv.applicantSignInPolicy,
  azureInstance: azureInstance,
  googleTagManagerId: commonEnv.googleTagManagerId,
  roles_case_1: "IWA_Admin",
  roles_case_2: "IWA_Admin_User",

  /**
   *  Moneris payment config
   */
  monerisCheckoutUrl: "https://gatewayt.moneris.com/chktv2/js/chkt_v2.00.js",
  monerisCheckoutMode: "qa",
  ferootAuditScriptMoneris: "https://pg.feroot.com/v1/bundle/ba8af88e-1d32-4845-b059-fe87be251ff8",

  tenant: tenant,
  msalApplicantConfigs: <MsalConfig>{
    auth: {
      clientId: clientId,
      authority: `${azureInstance}/${tenant}/${commonEnv.applicantSignInPolicy}`,
      // redirectUri: `${appUrl}/${commonEnv.azureApplicantCallbackUrl}`,
      redirectUri: `${appUrl}`,
      postLogoutRedirectUri: `${appUrl}/${commonEnv.azureApplicantCallbackUrl}`,
      knownAuthorities: [`${tenantName}.b2clogin.com`], // array of URIs that are known to be valid,
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: true,
    },

    system: {
      loadFrameTimeout: 30000,
    },
  },

  msalAgentConfigs: <MsalConfig>{
    auth: {
      clientId: clientId,
      authority: `${azureInstance}/${tenant}/${commonEnv.agentSignInPolicy}`,
      // redirectUri: `${appUrl}/${commonEnv.azureAgentCallbackUrl}`,
      redirectUri: `${appUrl}`,
      // postLogoutRedirectUri: `https://IAPTSTB2C.b2clogin.com/IAPDEVB2C.onmicrosoft.com/${commonEnv.agentSignInPolicy}/oauth2/v2.0/logout?post_logout_redirect_uri=${appUrl}/${commonEnv.azureAgentCallbackUrl}`,
      postLogoutRedirectUri: `${appUrl}/${commonEnv.azureAgentCallbackUrl}`,
      knownAuthorities: [`${tenantName}.b2clogin.com`], // array of URIs that are known to be valid,
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: true,
    },
    system: {
      loadFrameTimeout: 30000,
    },
  },
};
